import { render, staticRenderFns } from "./PrivateDonationForm.vue?vue&type=template&id=8188fc4c"
import script from "./PrivateDonationForm.vue?vue&type=script&lang=ts"
export * from "./PrivateDonationForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports